import React from "react";

import { capitalize } from "Libs/utils";

import Metric from "./Metric";
import { MetricsDeploymentService } from "./type";
import { serviceOrder } from "./util";

type ServiceUnitsMiniProps = {
  service: MetricsDeploymentService;
  isLoading?: boolean;
  kind?: string;
};

const ServiceUnitsMini = ({
  service,
  isLoading,
  kind
}: ServiceUnitsMiniProps) => {
  const data = service.metrics || {};
  const hasMetrics = Object.entries(data).some(([, value]) => value.length);

  if (!hasMetrics && !isLoading) return null;

  const orderedMetrics = serviceOrder(data);

  return (
    <>
      {orderedMetrics.map(([name, value]) => {
        return (
          !!value?.length && (
            <Metric
              key={name}
              name={name}
              value={value[value.length - 1]["average@value"]}
              max={value[value.length - 1].max}
              percentage={value[value.length - 1]["average@percentage"]}
              data={value.map(v => ({
                date: v.date,
                value: isNaN(v["average@value"]) ? 0 : v["average@value"]
              }))}
              isLoading={isLoading}
              kind={kind}
              serviceKind={capitalize(service.kind || "")}
            />
          )
        );
      })}
    </>
  );
};

export default React.memo(ServiceUnitsMini);
